import { useLocale } from 'next-intl';
import { forwardRef } from 'react';
import type { WidgetProps } from './TrustpilotWidget.types';

const Carousel = forwardRef<HTMLDivElement, WidgetProps>(({ children }, ref) => {
  const locale = useLocale();
  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      aria-hidden="true"
      data-locale={locale}
      data-template-id="53aa8912dec7e10d38f59f36"
      data-businessunit-id="5f561c385c8bbc00013d41f2"
      data-style-height="140px"
      data-style-width="100%"
      data-theme="light"
      data-stars="5"
      data-review-languages="en"
    >
      {children}
    </div>
  );
});

Carousel.displayName = 'TrustpilotCarousel';

export { Carousel };
